import { addDays, endOfMonth } from 'date-fns';

import { PaymentTerms } from '@/modules/clients/types/client';

const PAYMENT_TERM_DAYS: Partial<Record<PaymentTerms, number>> = {
  [PaymentTerms.Net7]: 7,
  [PaymentTerms.Net15]: 15,
  [PaymentTerms.Net30]: 30,
  [PaymentTerms.Net45]: 45,
  [PaymentTerms.Net60]: 60,
  [PaymentTerms.Net90]: 90,
  [PaymentTerms.CashInAdvance]: 0,
  [PaymentTerms.CashOnDelivery]: 0,
  [PaymentTerms.CashWithOrder]: 0,
};

interface CalculateInvoiceDueDateParams {
  issuedDate?: Date;
  paymentTerm: string;
}

/** Mirrors the backend payment-term rule for the read-only due-date preview. */
export function calculateInvoiceDueDate({
  issuedDate,
  paymentTerm,
}: CalculateInvoiceDueDateParams): Date | null {
  if (!issuedDate) return null;
  if (paymentTerm === PaymentTerms.EndOfMonth) return endOfMonth(issuedDate);

  const days = PAYMENT_TERM_DAYS[paymentTerm as PaymentTerms];
  return days === undefined ? null : addDays(issuedDate, days);
}
